///<reference path="../../components/short-cuts/models/short-cuts-state-manager.controller.ts"/>
///<reference path="../AppointmentBook/js/controllers/AppointmentBook.ts"/>
///<reference path="purchaseOrderNote.controller.ts"/>
module Meevo.Plugins.PurchaseOrder {

    import IShortCutsService = Meevo.Components.ShortCuts.IShortCutsService;
    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import ISelectItem = Meevo.Model.ISelectItem;
    import MaintenanceFormVisualState = Meevo.Model.MaintenanceFormVisualState;
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;

    class PurchaseOrderController extends ShortCutsStateManagerController {

        closeContext: Function;
        context: PurchaseOrderContext;
        mobileView: any = 'editCount';
        camera: boolean = true;
        protected onHandValue: number;
        public purchaseOrderId: string;
        public parentController: PurchaseOrderController;
        public showAdvancedMobile: boolean;
        protected noteText : string;
        protected shortCutGroup: { [key: number]: IShortCutGroup };

        get noun() {
            return Meevo.Model.NounEnum.PurchaseOrder;
        }

        get mode(): Meevo.Model.MaintenanceFormState {
            return this.context.mode;
        }

        public inventoryOptions: ISelectItem<ProductInventoryTypeEnum>[] = [
            {label: 'LABEL_SHOW_ALL', value: null},
            {label: 'LABEL_SHOW_RETAIL_ONLY', value: ProductInventoryTypeEnum.Retail},
            {label: 'LABEL_SHOW_SHOP_SUPPLY_ONLY', value: ProductInventoryTypeEnum.ShopSupply},
            {label: 'LABEL_SHOW_SHOP_RETAIL_SUPPLY_ONLY', value: ProductInventoryTypeEnum.RetailOrShopSupply },
            {label: 'LABEL_SHOW_MISC_SUPPLY_ONLY', value: ProductInventoryTypeEnum.Other },
        ];

        static $inject = [
            "meevo.AppSettings", "meevo.components.common.DataService",
            "meevo.components.modal.ModalService", "$rootScope", "$state",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "meevo.components.common.IdentityService",
            "$q", "$timeout",
            "meevo.components.common.ReportRouterService", "$mdSidenav", "$translate", '$scope',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.RoundingService',
            'meevo.components.common.ReportRouterService',
            "$window"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.ModalService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected securityChecker: Meevo.Components.Common.SecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected $q: ng.IQService,
            protected $timeout: ng.ITimeoutService,
            protected reportRouterService: Meevo.Components.Common.ReportRouterService,
            private $mdSidenav: any,
            protected $translate: ng.translate.ITranslateService,
            protected $scope: ng.IScope,
            protected shortCutsService: IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            protected $window: ng.IWindowService) {
            super($scope, $state, shortCutsService);

            //this.dialog = $mdDialog;
            let vm = this;
            vm.onHandValue = 0;
            vm.context = new PurchaseOrderContext(appSettings, dataService, modalService, this, securityChecker, trackingService, this.identityService, $q, $timeout, this.reportRouterService, $mdSidenav, $translate, $rootScope, $scope, busyService, this.roundingService, this.$window);
            vm.closeContext = (): void => {
                if (vm.context.mode == Meevo.Model.MaintenanceFormState.Pending)
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
                else {
                    this.modalService.confirmHandler("LABEL_CONFIRM_PO_CLOSING", Meevo.Components.Modal.ModalTranslationModes.Translate)
                        .then((response: boolean) => {
                            if (response) {
                                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
                            }
                        })
                }
                //this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }

            vm.noteText = "";
            vm.showAdvancedMobile = false;

            this.shortCutGroup = {
                [Meevo.Model.MaintenanceFormState.Pending]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_ADD',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        $timeout(() => {
                            $('button[meevo-btn-sc="DATA_MAINTENANCE_ADD"]:visible').click();
                        });
                        this.context.preventUsageTracking = false;
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.edit();
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_DELETE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.deletePurchaseOrder(this.context.purchaseOrder.id);
                        this.context.preventUsageTracking = false;
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        if (this.context.showReceival) {
                            this.context.savePoReceivals();
                        } else {
                            this.context.savePurchaseOrder();
                        }
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.cancel();
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_DELETE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.deletePurchaseOrder(this.context.purchaseOrder.id);
                        this.context.preventUsageTracking = false;
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Adding]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.saveNewPurchaseOrder();
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.view();
                        this.context.preventUsageTracking = false;
                    }
                }, {
                    shortCutName: 'DATA_MAINTENANCE_DELETE',
                    callback: () => {
                        this.context.preventUsageTracking = true;
                        this.context.deletePurchaseOrder(this.context.purchaseOrder.id);
                        this.context.preventUsageTracking = false;
                    }
                }])
            };

        }

        viewSwitch = (view: any): void => {
            this.mobileView = view;
        }
        alertModal() {

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/purchaseOrder/sectionViews/modal.mobile.template.html",
                controller: "meevo.plugins.purchaseOrder.PurchaseOrderController",
                controllerAs: "purchaseOrder",
                bindToController: true
                //clickOutsideToClose: true,
                //scope: this.context.product,
                //locals: {
                //    scope: this.context.product
                //}
            }

            this.modalService.showCustom(options);
        }
        qtyUpdateModal() {
            //var scope = this;
            //scope.onHandValue = scope.context.product.actualCount;
            //let options: Meevo.Components.Modal.IModalOptions = {
            //    templateUrl: "app/plugins/purchaseOrder/sectionViews/updateCount.modal.html",
            //    controller: "meevo.plugins.purchaseOrder.PurchaseOrderController",
            //    controllerAs: "purchaseOrder",
            //    bindToController: true,
            //    //clickOutsideToClose: true,
            //    resolve: {
            //        value: function() {
            //            return scope.onHandValue;
            //        }
            //    }
            //};


            //this.modalService.showCustom(options).then(function (onHand) {
            //    if (onHand != null && onHand != "") {
            //        scope.context.originalActualCount = scope.context.product.actualCount;
            //        scope.context.product.actualCount = parseInt(onHand);
            //        scope.onHandValue = onHand;
            //    }
            //}, function () {
            //    // modal was dimissed
            //});
        }

        showAddNoteModal() {
            this.showNoteModal(null).then(() => {
                this.context.getNotes(this.getPurchaseOrderId(), this.context.purchaseOrder.objectState);
            });
        };

        showEditNoteModal(note: any) {
            this.showNoteModal(angular.copy(note)).then((returnNote) => {
                if (returnNote) {
                    note.note = returnNote;
                }
            });
        };

        getPurchaseOrderId(): Guid {
            var poId = null;

            if (this.context != null && this.context.purchaseOrder != null) {
                poId = this.context.purchaseOrder.id;
            }

            if (poId == null) {
                poId = this.context.purchaseOrderId;
            }
            return poId;
        }

        showNoteModal(note: any): ng.IPromise<any> {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/purchaseOrder/sectionViews/noteTemplate.html",
                controller: "meevo.plugins.purchaseOrder.PurchaseOrderNoteController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    purchaseOrderId: this.getPurchaseOrderId(),
                    note: note,
                    preventUsageTracking: this.context.preventUsageTracking
                },
                resolve: {
                    value: function () {
                    }
                }
            };

            return this.modalService.showCustom(options);
        }

        closeCustomModal(): void {

            this.modalService.hide();
            //this.context.getNotes(this.context.purchaseOrderId);
        }

        submitCustomModal(): void {
            this.modalService.hideWithResponse(this.onHandValue);
        }

        toggleShowAdvancedMobile = (): void => {
            this.showAdvancedMobile = !this.showAdvancedMobile;
        }
    }

    angular.module("meevo.plugins.purchaseOrder")
        .controller("meevo.plugins.purchaseOrder.PurchaseOrderController", PurchaseOrderController);
}
